import Grid from "@mui/material/Grid";

import {
  CmpTypographyField,
  CmpRadioButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsContent({
  DetailReportRadioBtn,
  selectedOption,
  xtitle = "",
  //View
}) {
  return (
    <form className="" id="TransDetailReportContent">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={xtitle}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="UNCOMPLETED"
                label="UnCompleted"
                checked={selectedOption === "UNCOMPLETED"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="UNCOMPLETED_DETAIL"
                label="UnCompleted Detail"
                checked={selectedOption === "UNCOMPLETED_DETAIL"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="SUMMARY"
                label="Summary"
                checked={selectedOption === "SUMMARY"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
           
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="PENDGDODETIL"
                label="Pending DO Receipt"
                checked={selectedOption === "PENDGDODETIL"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="ITEMWISE"
                label="Detail"
                checked={selectedOption === "ITEMWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="SUMMARY001"
                label="Summary Detail"
                checked={selectedOption === "SUMMARY001"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
